import { CheckCircle } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const Product = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4 lg:px-8 bg-gray-50">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">
              {t('productTitle')}
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              {t('productDescription')}
            </p>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-teal-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">
                    {t('revenueAnalyticsTitle')}
                  </h3>
                  <p className="text-muted-foreground">
                    {t('revenueAnalyticsDesc')}
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-teal-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">
                    {t('patientInsightsTitle')}
                  </h3>
                  <p className="text-muted-foreground">
                    {t('patientInsightsDesc')}
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-teal-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">
                    {t('schedulingOptimizationTitle')}
                  </h3>
                  <p className="text-muted-foreground">
                    {t('schedulingOptimizationDesc')}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-t from-gray-50 to-transparent z-10 h-8 bottom-0"></div>
            <div className="bg-gradient-to-b from-gray-100 to-white rounded-xl overflow-hidden shadow-2xl">
              <img
                src="/placeholder.svg?height=600&width=1200"
                alt={t('productTitle')}
                width={1200}
                height={600}
                className="w-full"
                priority="true"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
